import React from "react";

interface RangeInfoCardProps {
  title: string;
  description: string;
  target: string;
}

const RangeInfoCard: React.FC<RangeInfoCardProps> = ({
  title,
  description,
  target,
}) => (
  <div className="bg-[#F6F8FB] rounded-xl p-5 w-[300px] min-w-[260px] max-w-[320px] flex flex-col gap-3">
    <h3 className="font-semibold text-[18px] text-[#1A2530]">{title}</h3>
    <p className="text-[14px] text-[#6B7280]">{description}</p>
    <div className="mt-2">
      <span className="bg-white rounded-full px-4 py-1 text-[13px] font-medium text-[#1A2530] shadow">
        {target}
      </span>
    </div>
  </div>
);

export default RangeInfoCard;
